"use client";

import React, { ReactNode, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

export const ResponsiveDisplay = ({
  breakpointUp,
  breakpointDown,
  children,
}: ResponsiveDisplayProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const sizeUp = breakpointUp
    ? breakpoints[breakpointUp as keyof typeof breakpoints]
    : null;

  const sizeDown = breakpointDown
    ? breakpoints[breakpointDown as keyof typeof breakpoints]
    : null;

  const matchesUp = useMediaQuery({
    query: sizeUp !== null ? `(min-width: ${sizeUp}px)` : "not all",
  });

  const matchesDown = useMediaQuery({
    query: sizeDown !== null ? `(max-width: ${sizeDown - 1}px)` : "not all",
  });

  if (!mounted) {
    return null;
  }

  const show =
    (sizeUp !== null && matchesUp) ||
    (sizeDown !== null && matchesDown);

  return show ? <>{children}</> : null;
};

export const breakpoints = {
  xxs: 0,
  xs: 376,
  sm: 576,
  md: 768,
  lg: 980,
  xl: 1200,
  xxl: 1440,
  xxxl: 1600,
  xxxxl: 1920,
};

export interface ResponsiveDisplayProps {
  breakpointUp?: string;
  breakpointDown?: string;
  children: ReactNode;
}